import {Injectable, inject} from '@angular/core';
import {
  NavigationStart,
  Router,
} from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class RouterNavigationService {

  private router = inject(Router);

  private sngHashPrefixUrl: string = '/#/';

  private sngFlowableReplaceUrl: string = `${this.sngHashPrefixUrl}sng`;

  private regex = /^\/#\/sng\//gi;

  /**
   * Method: Initializes the router navigation based on the event type.
   * @param event - The event triggering the router navigation.
   */
  async initRouterNavigation(event: any): Promise<void> {
    if (event instanceof NavigationStart) {
      await Promise.all([
        this.initFlowableRedirectRouterNavigation(event),
        this.initFlowableRouterNavigation(event),
      ]);
    }
  }

  /**
   * Method: Initializes the flowable redirect router navigation.
   * @param event - The event object containing the URL.
   */
  async initFlowableRedirectRouterNavigation(event: any): Promise<void> {
    if (event.url.match(this.regex)) {
      const redirectUrl = event.url.replace(this.sngFlowableReplaceUrl, '');
      await this.router.navigateByUrl(redirectUrl, {replaceUrl: true});
    }
  }

  /**
   * Method: Initializes the flowable router navigation.
   * If the current URL is the same as the SNG hash prefix URL,
   * it redirects to the previous navigation URL.
   * @param event - The event object containing the URL.
   */
  async initFlowableRouterNavigation(event: any): Promise<void> {
    if (event.url === this.sngHashPrefixUrl) {
      const redirectUrl = this.router?.getCurrentNavigation()?.previousNavigation?.finalUrl?.toString();
      if (!redirectUrl) {
        return;
      }
      await this.router.navigateByUrl(redirectUrl, {replaceUrl: true});
    }
  }

}
